<ag-progress-list
  [requestObject]="requestObject"
  [disableDetailFullScreen]="true"
></ag-progress-list>
